import fromDtoToKpiUnit from 'dto/kpi/fromDtoToKpiUnit.dto';

const fromDtoToPerformanceExtraData = (dto) =>
  dto
    ? {
        pastAvgBill: dto.past_avg_bill,
        futureAvgBill: dto.future_avg_bill,
        futureRevenue: dto.future_revenue,
        pastRevenue: dto.past_revenue,
        pastRetail: dto._past_retail,
        pastTotal: dto._past_total,
        rebooked: dto.rebooked,
        uniqueVisits: dto.unique_visits,
      }
    : void 1;

const fromDtoToPerformanceTooltipData = (dto) =>
  dto
    ? dto.map((item) => ({
        title: item.title,
        type: item.type,
        value: item.value,
      }))
    : void 1;

const fromDtoToPerformance = (dto) =>
  dto
    ? {
        id: dto.id,
        metricKey: dto.metric_key,
        metricType: fromDtoToKpiUnit(dto.metric_type),
        label: dto.label,
        performedValue: dto.performed_value,
        order: dto.order,
        tooltipData: fromDtoToPerformanceTooltipData(dto.tooltip_data),
        extraData: fromDtoToPerformanceExtraData(dto.extra_data), // BE will remove extraData soon
      }
    : dto;

export default fromDtoToPerformance;
